import { _FlightData, _GeoJsonData } from "../Models/commonModel";


export const buildGeoJson = (flightData: _FlightData) :  _GeoJsonData => {
    let headValue = flightData.hd ? parseInt(flightData.hd) : 0;
    const altValue = Math.round(Number(flightData.alt));
    const prop = {...flightData, head: headValue, alt: altValue}
    return {
        type: 'Feature',
        uid: flightData.uid,
        geometry: { type: 'Point', coordinates: [flightData.long, flightData.lat] },
        properties: prop,
    };

}
